import { render, staticRenderFns } from "./SidebarTreeBusinessTerms.vue?vue&type=template&id=141cfac3&scoped=true&lang=pug"
import script from "./SidebarTreeBusinessTerms.vue?vue&type=script&lang=js"
export * from "./SidebarTreeBusinessTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141cfac3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141cfac3')) {
      api.createRecord('141cfac3', component.options)
    } else {
      api.reload('141cfac3', component.options)
    }
    module.hot.accept("./SidebarTreeBusinessTerms.vue?vue&type=template&id=141cfac3&scoped=true&lang=pug", function () {
      api.rerender('141cfac3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/business_glossary/components/SidebarTreeBusinessTerms.vue"
export default component.exports